import type { Partner } from "@fscrypto/database";
import { Link } from "@remix-run/react";
import { Toggle } from "./ui/toggle";

export const PartnerList = ({
  partners,
  showAll = false,
  selectedPartner,
}: { partners: Partner[]; showAll?: boolean; selectedPartner?: Partner }) => {
  return (
    <nav className="flex flex-wrap gap-4 -mx-4 px-4">
      {showAll && (
        <Toggle key="all" asChild pressed={!selectedPartner}>
          <Link to="/" replace>
            All
          </Link>
        </Toggle>
      )}
      {partners.map((partner) => (
        <Toggle key={partner.id} asChild pressed={selectedPartner?.id === partner.id}>
          <Link to={`/${partner.slug}`} replace className="flex items-center gap-2 group">
            <img
              src={`https://res.cloudinary.com/dsr37ut2z/image/upload/assets/project-icons/${partner.slug}.svg`}
              alt={`${partner.displayName} logo`}
              className="w-5 h-5 object-contain opacity-75 group-hover:opacity-90 transition-all duration-200 group-pressed:opacity-100"
            />
            {partner.displayName}
          </Link>
        </Toggle>
      ))}
    </nav>
  );
};
